import React from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ChakraProvider } from '@chakra-ui/react';
import theme from '../../theme';
// cmx
import CMx from '../cmx/cmx-component';
import Login from '../login/login-component';
import AmplifyDeprecated from '../../views/amplify-deprecated/amplify-deprecated';
import store, { history } from '../../store/store';
import '../../core/session-management';

// assets (shared styles loaded via ../../styles in entry)
import '@fontsource/roboto';

function Template() {
  return (
    <ChakraProvider theme={theme}>
      <Provider store={store}>
        <Router history={history}>
          <Switch>
            <Route path={['/accelerate', '/accelerate/']} component={AmplifyDeprecated} />
            <Route path="/cmx" component={CMx} />
            <Route
              exact
              path={[
                '/',
                '/choose/context/',
                '/update-password/',
                '/forgot-password/',
                '/forgot-password/reset/',
                '/eula/',
                '/choose/service-line/',
                '/sso/:orgCode?'
              ]}
              component={Login}
            />
          </Switch>
        </Router>
      </Provider>
    </ChakraProvider>
  );
}

export default Template;
